import { doRequest } from "./helpers";

export default class SupportService {
  static async createTicket(data) {
    return doRequest("POST", `/support/`, {
      data,
    });
  }
}
